import { SVGProps } from 'react';

const CartScaleSmall = (props: SVGProps<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0_7_33)">
            <path
                d="M0.666504 0.666656H3.33317L5.11984 9.59332C5.1808 9.90025 5.34778 10.176 5.59153 10.3722C5.83529 10.5684 6.1403 10.6727 6.45317 10.6667H12.9332C13.246 10.6727 13.551 10.5684 13.7948 10.3722C14.0386 10.176 14.2055 9.90025 14.2665 9.59332L15.3332 3.99999H3.99984M6.6665 14C6.6665 14.3682 6.36803 14.6667 5.99984 14.6667C5.63165 14.6667 5.33317 14.3682 5.33317 14C5.33317 13.6318 5.63165 13.3333 5.99984 13.3333C6.36803 13.3333 6.6665 13.6318 6.6665 14ZM13.9998 14C13.9998 14.3682 13.7014 14.6667 13.3332 14.6667C12.965 14.6667 12.6665 14.3682 12.6665 14C12.6665 13.6318 12.965 13.3333 13.3332 13.3333C13.7014 13.3333 13.9998 13.6318 13.9998 14Z"
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                strokeWidth={1.33333}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_7_33">
                <rect width={16} height={16} fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export default CartScaleSmall;
